import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { getUserDisplayName } from 'utils/user';
import { getAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const EndUserReplaced = ({ entry, }) => {
    const text = useMemo(() => {
        const authorName = getAuthorName(entry);
        const newUserDisplayName = getUserDisplayName(entry.new_user, entry.new_user.id);
        const authorLink = (_jsx(UserLink, Object.assign({ userId: entry.author.id }, { children: authorName })));
        const newUserLink = (_jsx(UserLink, Object.assign({ userId: entry.new_user.id }, { children: newUserDisplayName })));
        switch (entry.reason) {
            case 'CONTACTS_MERGED':
                return (_jsxs(_Fragment, { children: [authorLink, " merged the contact", ' ', _jsx(Badge, Object.assign({ variant: "secondary", size: "small" }, { children: entry.old_user.id })), ' ', "into ", newUserLink] }));
            case 'AUTH_UPGRADE_ANONYMOUS_TO_CLAIMED':
                return _jsxs(_Fragment, { children: ["The contact ", newUserLink, " was upgraded to a claimed contact"] });
            default:
                return 'The contact has been replaced';
        }
    }, [entry]);
    const icon = useMemo(() => {
        switch (entry.reason) {
            case 'CONTACTS_MERGED':
                return 'combine';
            case 'AUTH_UPGRADE_ANONYMOUS_TO_CLAIMED':
                return 'user-plus';
        }
    }, [entry]);
    return _jsx(LogEntry, { entry: entry, text: text, icon: icon });
};
